<template>
  <div>
    <h1 class="page-title text-left">Site</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link
            :to="{ name: 'data-sites' }"
            class="pull-right ml-10"
            title="return to sites list"
            ><i class="fa fa-list"></i
          ></router-link>
          <i
            class="fa fa-pencil pointer pull-right"
            title="edit"
            v-on:click="showEdit"
          ></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">
          <dt>Site Name</dt>
          <dd>{{ form.data.name }}</dd>

          <dt>Contract</dt>
          <dd>{{ contractName(form.data.contractId) }}</dd>

          <dt>Coordinates</dt>
          <dd class="pointer" v-on:click="showMap(form.data.coordinates)">
            <i class="fa fa-map"></i> {{ form.data.coordinates.length }} points
          </dd>

          <dt>Address</dt>
          <dd
            class="pointer"
            v-on:click="
              showMap(
                `${form.data.address}, ${form.data.city} ${stateName(
                  form.data.stateId
                )} ${form.data.zip} `
              )
            "
          >
            <i class="fa fa-map"></i>
            {{ form.data.address }}<br />
            {{ form.data.city }}, {{ stateName(form.data.stateId) }}
            {{ form.data.zip }}
          </dd>

          <dt>Zone</dt>
          <dd>{{ zoneName(form.data.zoneId) }}</dd>

          <dt>Municipality</dt>
          <dd>{{ municipalityName(form.data.municipalityId) }}</dd>

          <dt>Habitat</dt>
          <dd>{{ habitatName(form.data.habitatId) }}</dd>

          <dt>Trap Schedule</dt>
          <dd>
            <span v-if="form.data.trapScheduleFrequency">
              {{ form.data.trapScheduleStart | date }}<br />
              every {{ form.data.trapScheduleFrequency }} days
            </span>
          </dd>

          <dt>Larval Schedule</dt>
          <dd>
            <span v-if="form.data.larvalScheduleFrequency">
              {{ form.data.larvalScheduleStart | date }}<br />
              every {{ form.data.larvalScheduleFrequency }} days
            </span>
          </dd>

          <dt>Adulticide Schedule</dt>
          <dd>
            <span v-if="form.data.adulticideScheduleFrequency">
              {{ form.data.adulticideScheduleStart | date }}<br />
              every {{ form.data.adulticideScheduleFrequency }} days
            </span>
          </dd>

          <div class="btn-group pull-right mt-20 mb-20 clearfix">
            <router-link
              :to="{
                name: 'data-larval-site-with-s',
                params: { id: this.$props.id },
              }"
              class="btn btn-primary"
              >Add Larval Site</router-link
            >
            <router-link
              :to="{
                name: 'data-trap-site-with',
                params: { type: 's', id: this.$props.id },
              }"
              class="btn btn-primary"
              >Add Trap Site</router-link
            >
            <button class="btn btn-primary" v-on:click="showCommentForm">
              Add Comment
            </button>
          </div>

          <div>
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation" class="active">
                <a
                  href="#recent-activity"
                  aria-controls="recent-activity"
                  role="tab"
                  data-toggle="tab"
                  >Recent Activity</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#trap-sites"
                  aria-controls="trap-sites"
                  role="tab"
                  data-toggle="tab"
                  >Trap Master</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#larval-sites"
                  aria-controls="larval-sites"
                  role="tab"
                  data-toggle="tab"
                  >Larval Master</a
                >
              </li>
              <li role="presentation">
                <a
                  href="#comments"
                  aria-controls="comments"
                  role="tab"
                  data-toggle="tab"
                  >Comments</a
                >
              </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="recent-activity">
                <table class="table table-striped">
                  <thead>
                    <th>Date Created</th>
                    <th>Data Type</th>
                    <th>Count</th>
                    <th>Treated/Type</th>
                    <th>Applicator</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="activity in recentActivities">
                      <td>{{ activity._date }}</td>
                      <td>{{ activity._type }}</td>
                      <td>{{ activity._count }}</td>
                      <td>{{ activity._treated }}</td>
                      <td>{{ activity._applicator }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: activity._route,
                            params: { id: activity.id },
                          }"
                        >
                          <i class="fa fa-ellipsis-h"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div role="tabpanel" class="tab-pane" id="trap-sites">
                <table class="table table-striped">
                  <thead>
                    <th>Active</th>
                    <th>Trap Number</th>
                    <th>Address/Location</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="trap in form.data.trapSites">
                      <td>
                        <i
                          class="fa"
                          :class="{
                            'fa-check-square-o': trap.isActive,
                            'fa-square-o': !trap.isActive,
                          }"
                        ></i>
                      </td>
                      <td>{{ trap.trapNumber }}</td>
                      <td>
                        {{ form.data.address }}<br />
                        {{ form.data.city }}, <br />
                        {{ stateName(form.data.stateId) }} {{ form.data.zip }}
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'data-trap-site-details',
                            params: { id: trap.id },
                          }"
                          ><i class="fa fa-ellipsis-h"></i
                        ></router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div role="tabpanel" class="tab-pane" id="larval-sites">
                <table class="table table-striped">
                  <thead>
                    <th>Active</th>
                    <th>Landowner Address</th>
                    <th>Contact</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="larvalSite in form.data.larvalSites">
                      <td>
                        <i
                          class="fa"
                          :class="{
                            'fa-check-square-o': larvalSite.isActive,
                            'fa-square-o': !larvalSite.isActive,
                          }"
                        ></i>
                      </td>
                      <td>
                        {{ larvalSite.address }}, {{ larvalSite.city }},
                        {{ stateName(larvalSite.stateId) }} {{ larvalSite.zip }}
                      </td>
                      <td>
                        {{ larvalSite.contactDate | date }}<br />
                        {{ larvalSite.contactPerson }}<br />
                        {{ larvalSite.phoneNumber }}
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'data-larval-site-details',
                            params: { id: larvalSite.id },
                          }"
                          ><i class="fa fa-ellipsis-h"></i
                        ></router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div role="tabpanel" class="tab-pane" id="comments">
                <table class="table table-striped">
                  <thead>
                    <th>Date</th>
                    <th>By</th>
                    <th>Comment</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="comment in form.data.comments">
                      <td>{{ comment.updatedAt | date }}</td>
                      <td>
                        {{ comment.user.firstName }} {{ comment.user.lastName }}
                      </td>
                      <td>{{ comment.body }}</td>
                      <td class="nowrap">
                        <i
                          class="fa fa-pencil pointer mr-10"
                          title="Edit"
                          v-on:click="commentEdit(comment)"
                        ></i>
                        <i
                          class="fa fa-times pointer"
                          title="Delete"
                          v-on:click="commentDelete(comment.id)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </dl>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <comment-form :form="commentForm"></comment-form>
    <google-map ref="gmap"></google-map>
  </div>
</template>

<script>
import moment from 'moment';
import SitesService from '@/services/SitesService';
import LarvalSitesService from '@/services/LarvalSitesService';
import LarvicidesService from '@/services/LarvicidesService';
import MosquitoesService from '@/services/MosquitoesService';

import LandingRatesService from '@/services/LandingRatesService';
import LchemicalsService from '@/services/LchemicalsService';
import TrapSitesService from '@/services/TrapSitesService';
import CommentsService from '@/services/CommentsService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/site_details';
import commentForm from '@/components/forms/comments';
import googleMap from '@/components/googleMap';

export default {
  name: 'site_details',

  components: {
    siteForm,
    googleMap,
    commentForm,
  },

  props: ['id'],

  data() {
    return {
      recentActivities: [],
      form: new Form(SitesService, {
        coordinates: [],
      }),
      commentForm: new Form(CommentsService, {
        commentableId: this.id,
        commentableType: 'Site',
      }),
    };
  },

  methods: {
    contractName(id) {
      return this.$store.getters.contractNameById(id);
    },
    municipalityName(id) {
      return this.$store.getters.municipalityNameById(id);
    },
    habitatName(id) {
      return this.$store.getters.habitatNameById(id);
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    achemicalName(id) {
      return this.$store.getters.achemicalNameById(id);
    },
    lchemicalName(id) {
      return this.$store.getters.lChemicalNameById(id);
    },
    applicatorName(id) {
      return this.$store.getters.applicatorNameById(id);
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    showMap(coordinates) {
      this.$refs.gmap.showMap(coordinates);
    },
    showEdit() {
      this.form.showEdit({ id: this.id, list: true });
      if (!this.form.data.coordinates.hasOwnProperty('0')) {
        this.form.data.coordinates = [{ lat: null, lon: null }];
      }
    },
    showCommentForm() {
      this.commentForm.showEdit({
        title: 'Add Comment',
        formId: '#comment-edit',
      });
    },
    commentDelete(id) {
      this.commentForm.destroy(id, { comment: true });
    },
    commentEdit(comment) {
      this.commentForm.data.body = comment.body;
      this.commentForm.showEdit({
        id: comment.id,
        title: 'Edit Comment',
        formId: '#comment-edit',
      });
    },
    afterComment() {
      if (this.$route.path.indexOf('sites') > -1 && this.$props.id) {
        this.form.getDetails(this.$props.id);
      }
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YY');
    },
    prepareAdultSurveillances(trapSiteIds, callback) {
      let result = [];
      const mapper = (index = 0) => {
        if (index === trapSiteIds.length) {
          return callback(result);
        }

        const id = trapSiteIds[index];
        TrapSitesService.getDetails(id).then((res) => {
          const { adultSurveillances } = res;
          if (adultSurveillances) {
            const adultSurvIds = Object.keys(adultSurveillances);
            const adultSurvActivity = adultSurvIds.map((id) => {
              const adultSurv = adultSurveillances[id];
              const date = this.formatDate(adultSurv.dateTrapSet);
              const mosquitoCount = adultSurv.adultSurveillanceMosquitoes.reduce(
                (sum, { mosquitoCount }) => sum + mosquitoCount,
                0
              );

              return {
                ...adultSurv,
                _date: date,
                _type: 'Trap Count',
                _count: mosquitoCount,
                _treated: 'N/A',
                _applicator: adultSurv.idInitials,
                _sortDate: date,
                _route: 'data-adult-surveillance-details',
              };
            });
            result = [...result, ...adultSurvActivity];
          }

          const nextIndex = index + 1;
          mapper(nextIndex);
        });
      };
      mapper();
    },
    prepareLarvicides(larvicides) {
      const larvaCount = this.$store.getters.larvaCountNameById;
      return larvicides.map((larvicide) => {
        const eggCount = larvaCount(larvicide.eggs) || '';
        const larvaeCount = larvaCount(larvicide.larvae) || '';
        const pupaeCount = larvaCount(larvicide.pupae) || '';
        const eggText = eggCount && `Eggs ${eggCount}`;
        const larvaeText = larvaCount && `Larvae ${larvaeCount}`;
        const pupaeText = pupaeCount && `Pupae ${pupaeCount}`;
        const texts = [eggText, larvaeText, pupaeText].filter((text) => text);
        const {
          createdAt,
          appliedDate,
          applicatorId,
          lchemicalId,
          wetDry,
        } = larvicide;
        const lChemicalName = this.lchemicalName(lchemicalId) || '';
        const treated = lChemicalName && `${lChemicalName} - ${wetDry}`;
        return {
          ...larvicide,
          _date: this.formatDate(appliedDate),
          _type: 'Larvicide',
          _count: texts.join(' / '),
          _treated: treated,
          _applicator: this.applicatorName(applicatorId),
          _route: 'data-larvicide-details',
        };
      });
    },
    prepareAdulticides(adulticides) {
      return adulticides.map((adulticide) => {
        const { applicationDate, achemicalId, applicatorId } = adulticide;
        return {
          ...adulticide,
          _date: this.formatDate(applicationDate),
          _type: 'Adulticide',
          _count: 'N/A',
          _treated: this.achemicalName(achemicalId),
          _applicator: this.applicatorName(applicatorId),
          _route: 'data-adulticide-details',
        };
      });
    },
    prepareLandingRates(landingRates, callback) {
      const mapper = (index = 0) => {
        if (index === landingRates.length) {
          return callback(landingRates);
        }

        const { id } = landingRates[index];
        LandingRatesService.getDetails(id).then((res) => {
          const { landingRateMosquitoes, inspectorId, observedDate } = res;
          const count = landingRateMosquitoes.reduce(
            (sum, { mosquitoCount }) => sum + mosquitoCount,
            0
          );
          landingRates[index] = {
            ...res,
            _date: this.formatDate(observedDate),
            _type: 'Landing Rate',
            _count: count,
            _treated: 'N/A',
            _applicator: this.applicatorName(inspectorId),
            _route: 'data-landing-rate-details',
          };
          mapper(index + 1);
        });
      };
      mapper();
    },
    buildRecentActivities(site) {
      const sortAndSet = (site) => {
        const {
          adulticides,
          larvicides,
          adultSurveillances,
          landingRates,
        } = site;
        const all = [
          ...adulticides,
          ...larvicides,
          ...adultSurveillances,
          ...landingRates,
        ];
        all.sort((a, b) => {
          return moment(a._date).isBefore(b._date) ? 1 : -1;
        });
        this.recentActivities = all;
      };

      site.larvicides = this.prepareLarvicides(site.larvicides);
      site.adulticides = this.prepareAdulticides(site.adulticides);
      const trapSiteIds = Object.keys(site.trapSites || {});
      this.prepareAdultSurveillances(trapSiteIds, (adultSurveillances) => {
        site.adultSurveillances = adultSurveillances;
        this.prepareLandingRates(site.landingRates, (landingRates) => {
          this.landingRates = landingRates;
          sortAndSet(site);
        });
      });
    },
    geoJSONFromCoordinatesAndAdditionalCoordinates(
      coordinates,
      additionalCoordinates
    ) {
      if (
        coordinates.length == 1 &&
        coordinates[0]['lon'] &&
        coordinates[0]['lat'] &&
        !additionalCoordinates
      ) {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [
              parseFloat(coordinates[0]['lon']),
              parseFloat(coordinates[0]['lat']),
            ],
          },
          properties: {},
        };
      } else if (coordinates.length > 1) {
        var geoJSONCoordinates = [];
        var coordinateGeoJSONCoordinates = coordinates.map((coord) => {
          return [parseFloat(coord.lon), parseFloat(coord.lat)];
        });
        coordinateGeoJSONCoordinates.push(coordinateGeoJSONCoordinates[0]);
        geoJSONCoordinates.push(coordinateGeoJSONCoordinates);
        if (additionalCoordinates) {
          const additionalCoordinatesGeoJSONCoordinates = additionalCoordinates.map(
            (additionalCoordinatesEntry) => {
              const coordinateSet = additionalCoordinatesEntry.coordinateSet;
              var geoJSONCoordinatesSet = coordinateSet.map(
                (coordinateLatLngEntry) => {
                  return [
                    parseFloat(coordinateLatLngEntry.lon),
                    parseFloat(coordinateLatLngEntry.lat),
                  ];
                }
              );
              geoJSONCoordinatesSet.push(geoJSONCoordinatesSet[0]);
              return geoJSONCoordinatesSet;
            }
          );
          geoJSONCoordinates = geoJSONCoordinates.concat(
            additionalCoordinatesGeoJSONCoordinates
          );
        }
        return {
          type: 'Feature',
          geometry: {
            type: 'MultiPolygon',
            coordinates: geoJSONCoordinates,
          },
          properties: {},
        };
      } else {
        return null;
      }
    },
  },

  created() {
    window.bus.$on('comment-created', () => {
      this.afterComment();
    });
    window.bus.$on('comment-updated', () => {
      this.afterComment();
    });
    window.bus.$on('comment-deleted', () => {
      this.afterComment();
    });
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getDetails(this.id).then(() => {
        const geojson = this.geoJSONFromCoordinatesAndAdditionalCoordinates(
          this.form.data.coordinates,
          this.form.data.additionalCoordinates
        );
        this.$store.commit('setGeoJSON', geojson);
        const { form } = this;
        const landingRateSearch = {
          field: 'site_id',
          term: this.id,
        };

        LandingRatesService.search(landingRateSearch).then(({ data }) => {
          form.data.landingRates = data;
          this.buildRecentActivities(form.data);
        });
      });
    });
  },
};
</script>

<style lang="scss">
.nav-tabs {
  margin-top: 50px;
}
</style>
